import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.is-integer.js";
import dayjs from "dayjs";
import { mapState } from "vuex";
export default {
  inheritAttrs: false,
  components: {},
  props: ["data", "editType", "userId"],
  data: function data() {
    return {
      ruleForm: {
        name: "",
        phoneNum: "",
        startTime: "",
        days: "",
        amount: "",
        deposit: "",
        city: "",
        company: ""
        // remarks: "",
      },
      rules: {
        company: [{
          required: true,
          message: "请选择所属公司",
          trigger: "blur"
        }],
        city: [{
          required: true,
          message: "请选择城市",
          trigger: "blur"
        }],
        startTime: [{
          required: true,
          message: "请选择账户开通时间",
          trigger: "change"
        }],
        days: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (value === null || value === "") {
              return callback(new Error("请填写开通天数"));
            }
            if (!Number.isInteger(value)) {
              callback(new Error("请填写数字"));
            } else {
              if (value < 1) {
                callback(new Error("开通天数不能为0"));
              } else if (value > 400) {
                callback(new Error("开通天数不能大于400"));
              } else {
                callback();
              }
            }
          }
        }],
        amount: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (value === null || value === "") {
              return callback(new Error("请填写金额"));
            }
            if (!Number.isInteger(value)) {
              callback(new Error("请填写数字"));
            } else {
              if (value > 40000) {
                callback(new Error("金额不能大于40000"));
              } else {
                callback();
              }
            }
          }
        }]
      },
      pickerOptions: {
        // disabledDate(time) {
        //     var isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
        //     dayjs.extend(isSameOrBefore)
        //     return dayjs(dayjs().format("YYYY-MM-DD")).isSameOrBefore(dayjs(time));
        // },
      },
      disLoading: false,
      companyLoading: false,
      cityList: [],
      companyList: [],
      depositUpdate: false,
      typeTags: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("d2admin/user", ["info"])), {}, {
    depositDisabled: function depositDisabled() {
      return this.editType == 1 ? true : this.editType == 2 ? false : false;
    }
  }),
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.getHouseFilterType();
    this.getCompanyList();
  },
  methods: {
    goCompany: function goCompany() {
      window.open("#/quarter/company?type=add");
    },
    onOpen: function onOpen() {
      this.ruleForm = {
        name: "",
        phoneNum: "",
        startTime: "",
        days: "",
        amount: "",
        deposit: "",
        city: "",
        company: ""
        // remarks: "",
      };
      this.depositUpdate = false, this.disLoading = false;
      if (this.data != null) {
        this.ruleForm = Object.assign({}, this.data);
      }
    },
    onClose: function onClose() {},
    close: function close() {
      this.$emit("update:visible", false);
    },
    handelConfirm: function handelConfirm() {
      var _this = this;
      this.$refs["ruleForm"].validate(function (valid) {
        if (!valid) return;
        if (_this.data) {
          _this.$confirm("确认操作, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            return _regenerator().w(function (_context) {
              while (1) switch (_context.n) {
                case 0:
                  // return
                  _this.updateAccount();
                case 1:
                  return _context.a(2);
              }
            }, _callee);
          }))).catch(function () {});
        } else {}
      });
    },
    // 开通/续费/编辑
    updateAccount: function updateAccount() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _this2.disLoading = true;
              _this2.ruleForm.createName = _this2.info.name;
              if (_this2.editType == 1) {
                _this2.ruleForm.openType = "edit";
              } else if (_this2.editType == 2) {
                _this2.ruleForm.openType = "open";
              } else if (_this2.editType == 3) {
                _this2.ruleForm.openType = "renewal";
              }
              _context2.p = 1;
              _context2.n = 2;
              return _this2.$api.saveOrUpdateBrandQuarterOrder(_this2.ruleForm);
            case 2:
              res = _context2.v;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              _this2.disLoading = false;
              return _context2.a(2);
            case 4:
              debugger;
              if (!(_this2.editType == 1)) {
                _context2.n = 5;
                break;
              }
              _this2.$message.success("保存成功");
              // 操作上报
              _this2.$operationLog.push({
                code: "edit",
                userId: _this2.userId,
                operationType: "user"
              });
              _context2.n = 8;
              break;
            case 5:
              if (!(_this2.editType == 2)) {
                _context2.n = 7;
                break;
              }
              _this2.$message.success("开通成功");
              _context2.n = 6;
              return _this2.$api.setRiskDeviceAndCategory({
                'user_id': _this2.userId
              });
            case 6:
              // 操作上报
              _this2.$operationLog.push({
                code: "activate",
                userId: _this2.userId,
                operationType: "order",
                operationOrderType: "quarter"
              });
              _context2.n = 8;
              break;
            case 7:
              _this2.$message.success("续费成功");
              // 操作上报
              _this2.$operationLog.push({
                code: "renewal",
                userId: _this2.userId,
                operationType: "order",
                operationOrderType: "quarter"
              });
            case 8:
              console.log('===========', res);
              _this2.disLoading = false;
              _this2.close();
              _this2.$emit("confirm");
            case 9:
              return _context2.a(2);
          }
        }, _callee2, null, [[1, 3]]);
      }))();
    },
    getHouseFilterType: function getHouseFilterType() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return _this3.$api.getHouseFilterType();
            case 1:
              res = _context3.v;
              _this3.cityList = res.data.cityList;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getCompanyList: function getCompanyList(query) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _this4.companyLoading = true;
              _context4.n = 1;
              return _this4.$api.findAllBqCompanyinfo({
                companyName: query,
                pageNum: 1,
                pageSize: 20
              });
            case 1:
              res = _context4.v;
              _this4.companyLoading = false;
              _this4.companyList = res.data.content;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    remoteMethod: function remoteMethod(query) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              if (query !== "") {
                _this5.getCompanyList(query);
              }
            case 1:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};